import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="relative bg-foreground-950 py-20 md:py-28">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end gap-4 mb-12">
          <div className="flex-shrink-0">
            <span className="inline-block px-3 py-1 rounded-full border border-background-50/20 text-xs font-medium text-background-50/60">
              Shop Categories
            </span>
          </div>
          <div className="flex-1 md:ml-8">
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50">
              Explore All Categories
            </h2>
          </div>
        </div>

        <div className="flex gap-4 overflow-x-auto pb-4 scrollbar-hide -mx-4 px-4 md:px-6" style={{ scrollSnapType: 'x mandatory' }}>
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex-shrink-0 w-44 md:w-52 rounded-xl overflow-hidden bg-secondary-100/10 transition-all duration-300 cursor-pointer hover:bg-secondary-100/20 group"
              style={{ scrollSnapAlign: 'start' }}
            >
              <div className="w-full h-40 md:h-48 overflow-hidden bg-foreground-800/30">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  title={cat.name}
                />
              </div>
              <div className="p-4">
                <p className="text-sm font-medium text-background-50/80 group-hover:text-background-50 transition-colors duration-200">
                  {cat.name}
                </p>
                <p className="text-xs text-background-50/40 mt-1 group-hover:text-background-50/60 transition-colors duration-200">
                  Browse collection
                </p>
              </div>
            </a>
          ))}

          <div className="flex-shrink-0 w-12 md:w-20"></div>
        </div>

        <div className="mt-8 text-center">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center gap-2 rounded-full border border-background-50/20 px-6 py-2.5 text-sm font-medium text-background-50/70 transition-all duration-200 cursor-pointer hover:border-background-50/40 hover:text-background-50"
          >
            View All Categories
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}